<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(4px);\n"' class="shadow sticky-top" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container" >
                <template #default>   <m-nav-2 v-bind='{...{"shoppingCart":true,"dashboardLink":"https:\/\/dash.royahayefarda.ir\/dashboard","AuthLink":{"name":"Login"}},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-nav-2></template>
                </m-div></template>
                </m-div><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"background:#fff;\n\nbackground-size:cover;\nbackground-repeat: no-repeat;\n"' class="f100 py-5 " >
                <template #default>   <m-footer-4 v-bind='{...{"menuPosition":"blog_footer"},...{}}' :style='""' class="" ></m-footer-4></template>
                </m-div><m-chat-widget-1 v-bind='{...{},...{}}' :style='""' class="" ></m-chat-widget-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav2 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav2/Nav2'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mFooter4 from '@moeinmdn/miw-alpha-components/src/package/Footers/Footer4'; import mChatWidget1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Widget/ChatWidget1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mNav2,mLoading3,mUpdateSiteMessage1,mFooter4,mChatWidget1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
